// Total del carrito de la pestaña Cobro según el SERVIDOR (Fase 1.2, Q41):
// la pantalla ya no suma precio × cantidad. `null` mientras carga o si la
// cotización falla — el llamador muestra entonces "estimado".
import { useEffect, useState } from 'react';
import { cotizarCarrito, type LineaAtencionInput } from './cobro';

export function useCotizacionCobro(lineas: LineaAtencionInput[], specialtyId?: string): number | null {
  const [totalCents, setTotalCents] = useState<number | null>(null);
  const clave = JSON.stringify(lineas);
  useEffect(() => {
    setTotalCents(null);
    if (lineas.length === 0) return;
    let cancelado = false;
    const espera = setTimeout(() => {
      void cotizarCarrito(lineas, specialtyId).then((c) => {
        if (!cancelado && c) setTotalCents(c.totalCents);
      });
    }, 300);
    return () => {
      cancelado = true;
      clearTimeout(espera);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- `clave` es la identidad estable de `lineas` (se recrea en cada render)
  }, [clave, specialtyId]);
  return lineas.length === 0 ? 0 : totalCents;
}
